// Standard library imports
import { useContext, useMemo } from 'react';

// External libary importa
import lodashGet from 'lodash/get';

// Internal module imports
import { AuthContext } from '../context/AuthContext';
import { ADMIN_USER_ROLES, ROOT_USER_ROLES } from '../constants';

export const useUserRole = () => {
    const { state } = useContext(AuthContext);

    return useMemo(() => {
        const userRole = lodashGet(state, ['user', 'userRole']);
        const adminId = lodashGet(state, ['user', 'adminId']);
        const isRootUser = ROOT_USER_ROLES.includes(userRole);
        const isAdminUser = ADMIN_USER_ROLES.includes(userRole);

        return { isRootUser, isAdminUser, adminId };
    }, [state?.user?.userRole]);
};
